import { FormControlLabel as FormControlLabelBase, styled } from '@mui/material'

export const DiseasesContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
})

export const ToggleContainer = styled('div')<{ checked?: boolean }>(({ theme, checked }) => ({
  padding: theme.spacing(1.5, 2),
  backgroundColor: theme.palette.common.white,
  color: theme.palette.grey[800],
  borderRadius: '4px 4px 0px 0px',
  borderBottom: checked ? `0.5px solid ${theme.palette.grey[300]}` : 'none',
}))

export const FormControlLabel = styled(FormControlLabelBase)<{ error?: boolean }>(({ error, theme }) => ({
  marginLeft: 0,
  justifyContent: 'space-between',
  width: '100%',
  color: error ? theme.palette.error[500] : 'currentColor',
}))
